import { render } from "./LogoSlider.vue?vue&type=template&id=1bccf81c&scoped=true"
import script from "./LogoSlider.vue?vue&type=script&lang=js"
export * from "./LogoSlider.vue?vue&type=script&lang=js"

import "./LogoSlider.vue?vue&type=style&index=0&id=1bccf81c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bccf81c"]])

export default __exports__